import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, createStyles } from '@material-ui/core';
import DisplaySelectedUnitTimeFrame from '@components/SchedulePage/DisplaySelectedUnitTimeFrame/DisplaySelectedUnitTimeFrame';
import Interval from '@interfaces/Interval';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
		},
	}),
);

type BlockColumnHeaderCommonProps = {
	timeFrames: Interval[];
};

const ColumnHeaderCommon: React.FC<BlockColumnHeaderCommonProps> = ({ timeFrames }) => {
	const classes = useStyles();

	return (
		<Box className={classes.root} data-field="block-column-header-top">
			<Box>
				{
					timeFrames.map((timeframe, i) => (
						<DisplaySelectedUnitTimeFrame
							key={`${timeframe.start.toISOString()}::${timeframe.end.toISOString()}::${i}`}
							timeFrame={timeframe}
							variant="body2"
						/>
					))}
			</Box>
		</Box>
	);
};

export default ColumnHeaderCommon;
